module.exports = __webpack_public_path__ + "img/logo.a088e160.png";